const galleryTabs = document.querySelectorAll("[data-gallery-tab]");
const galleryPanels = document.querySelectorAll("[data-gallery-panel]");
const galleryFilters = document.querySelectorAll("[data-gallery-filter]");
const lightbox = document.querySelector("[data-gallery-lightbox]");
const lightboxImage = document.querySelector("[data-gallery-lightbox-image]");
const lightboxClose = document.querySelector("[data-gallery-close]");

let activePanel = "photos";
let activeFilter = "all";

function updateGallery() {
  galleryPanels.forEach((panel) => {
    const isActive = panel.dataset.galleryPanel === activePanel;
    panel.classList.toggle("is-active", isActive);
    panel.hidden = !isActive;
  });

  const activeItems = document.querySelectorAll(`[data-gallery-panel="${activePanel}"] [data-gallery-city]`);
  activeItems.forEach((item) => {
    const isVisible = activeFilter === "all" || item.dataset.galleryCity === activeFilter;
    item.hidden = !isVisible;
  });
}

galleryTabs.forEach((tab) => {
  tab.addEventListener("click", () => {
    activePanel = tab.dataset.galleryTab;
    galleryTabs.forEach((button) => button.classList.toggle("is-active", button === tab));
    updateGallery();
  });
});

galleryFilters.forEach((filter) => {
  filter.addEventListener("click", () => {
    activeFilter = filter.dataset.galleryFilter;
    galleryFilters.forEach((button) => button.classList.toggle("is-active", button === filter));
    updateGallery();
  });
});

document.querySelectorAll(".gallery-photo").forEach((photo) => {
  photo.addEventListener("click", () => {
    if (!lightbox || !lightboxImage) return;
    lightboxImage.src = photo.dataset.galleryFull;
    lightbox.classList.add("is-open");
    lightbox.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
  });
});

function closeLightbox() {
  if (!lightbox || !lightboxImage) return;
  lightbox.classList.remove("is-open");
  lightbox.setAttribute("aria-hidden", "true");
  lightboxImage.src = "";
  document.body.style.overflow = "";
}

lightboxClose?.addEventListener("click", closeLightbox);
lightbox?.addEventListener("click", (event) => {
  if (event.target === lightbox) closeLightbox();
});

document.addEventListener("keydown", (event) => {
  if (event.key === "Escape") closeLightbox();
});

updateGallery();
